import { render } from "./ApplicantLogDialog.vue?vue&type=template&id=f55bfcc2&scoped=true"
import script from "./ApplicantLogDialog.vue?vue&type=script&lang=js"
export * from "./ApplicantLogDialog.vue?vue&type=script&lang=js"

import "./ApplicantLogDialog.vue?vue&type=style&index=0&id=f55bfcc2&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f55bfcc2"]])

export default __exports__